/**
 * set, get and delete cookies
 */

export function setCookie(cname, cvalue, exdays, domain) {
  let d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  let expires = 'expires=' + d.toUTCString()
  
  const isSecure = location.protocol === 'https:' ? 'Secure;' : '';
  const sameSite = 'SameSite=Lax;';
  const domainPart = domain ? `domain=${domain};` : '';

  document.cookie = `${cname}=${encodeURIComponent(cvalue)}; ${domainPart} ${expires}; path=/; ${isSecure} ${sameSite}`;
}

export function getCookie(cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export function deleteCookie(name) {
  let domain = location.hostname
  let x = domain.indexOf('.')
  if (x >= 0) {
    domain = domain.substring(x, domain.length)
  }
  
  const isSecure = location.protocol === 'https:' ? 'Secure;' : '';
  const sameSite = 'SameSite=Lax;';

  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=${domain}; path=/; ${isSecure} ${sameSite}`;
}

export function getDomain (url) {
  return url.replace(/^(?:https?:\/\/)?(?:[^/]+\.)?([^./]+\.[^./]+).*$/, '$1')
}

export default {
  setCookie,
  getCookie,
  deleteCookie,
  getDomain,
}



// WEBPACK FOOTER //
// ./scripts/util/cookies.js